<template>
  <b-form @submit.prevent="saveAchievement" class="w-100">
    <h2 class="pb-2" v-if="title">{{ title }}</h2>
    <p class="pb-2" v-if="description">{{ description }}</p>
    <h3 class="card-title" v-if="profile">Manage Achievement :</h3>
    <b-button variant="primary" @click="addAchievement()" class="mb-2 ml-auto">
      <feather-icon icon="PlusCircleIcon" size="18" />
    </b-button>
    <b-row
      v-for="(achievement, index) in form.achievements"
      :key="index"
      class="align-items-end w-100 mb-1"
    >
      <b-col cols="10" style="min-height: 70px">
        <label>Achievement</label>
        <div>
          <Input
            v-model="form.achievements[index]"
            placeholder="Enter Achievement"
            style="width: 100%"
            type="text"
          />
          <small
            v-if="form.errors.has('achievements.' + index)"
            class="text-danger"
            >This field is required
          </small>
        </div>
      </b-col>

      <b-col cols="12" lg="2" style="min-height: 50px">
        <b-button
          variant="danger"
          @click="removeAchievement(index)"
          class="w-100"
          :disabled="form.achievements.length == 1"
        >
          <feather-icon icon="XCircleIcon" size="18" />
        </b-button>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-between">
      <div>
        <router-link to="/profile" v-if="profile">
          <b-button variant="primary"> Back to profile </b-button>
        </router-link>
      </div>
      <div>
        <b-button
          variant="primary"
          type="submit"
          :disabled="form.busy"
          style="margin-right: 30px"
        >
          Save</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import { isArray } from "lodash";
import { HasError, AlertError } from "vform/src/components/bootstrap5";

export default {
  props: [
    "title",
    "nextOnboard",
    "nextTitle",
    "nextName",
    "description",
    "profile",
  ],
  data() {
    return {
      form: new Form({
        achievements: [''],
      }),
    };
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    HasError,
    AlertError,
  },

  mounted() {
    this.showAchievement();
  },
  methods: {
    showAchievement() {
      axios
        .get("/candidate/achievement")
        .then((res) => {
          
          if((res.data.achievements.length === 0 && isArray(res.data.achievements)) || res.data.achievements.achievements == null){          
            this.form.achievements = [''];
          }else{
            this.form.achievements = res.data.achievements.achievements;
          }
        })
        .catch((e) => {
            this.e(e.response.data.error);
        });
    },
    saveAchievement() {
      this.form
        .post(`/candidate/achievement`)
        .then((res) => {
          this.showAchievement();
          this.s(res.data.message);
        })
        .catch((e) => {
          this.e(e.response.data.message);
        });
    },
    addAchievement() {
      this.form.achievements.push('');
    },
    removeAchievement(index) {
      this.form.achievements.splice(index, 1);
    },
  },
};
</script>
